import React, {Component} from "react";
import {Link} from "react-router-dom";
import EventHelper from "../../../helpers/EventHelper";
import MomentDate from "../../../components/MomentDate";

class Event extends Component {
	render() {
		const {event, collations} = this.props;

		const teams = EventHelper.parseTeams(event.team1, event.team2);
		const description = EventHelper.parseDescription(event.description);

		const tracker = description.getTracker();
		const tv = description.getTv();
		const video_online = description.getVideoOnline();

		const eventLink = collations.length > 0 ?
			<Link to={`/line-leagues/${collations[0].league_id}/${collations[0].line}`} className="underline">{teams}</Link> :
			<span>{teams}</span>;

		return (
			<div key={event.id} className="tr">
				<div className="td time full">
					<MomentDate date={event.time} isParseAll={false} withTime={true}/>
				</div>
				<div className="td players">
					{eventLink}
				</div>
				<div className="td service">
					{/*<div className="services-colored">*/}
						{/*<div className={`services-colored__zone ${tracker === '' ? 'hidden' : ''}`}></div>*/}

						{/*<div className={`services-colored__tv ${tv === '' ? 'hidden' : ''}`} title={tv}></div>*/}

						{/*<div className={`services-colored__translation ${video_online === '' ? 'hidden' : ''}`} title="Доступна видеотрансляция" onClick={() => {EventHelper.openVideoOnline(video_online)}}></div>*/}
					{/*</div>*/}
				</div>
			</div>
		);
	}
}

export default Event;


// WEBPACK FOOTER //
// ./src/app/pages/LiveSoon/modules/Event.js